import React from 'react';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { Form, Col, Card } from 'react-bootstrap';

import { campotexto, camposelect } from '../campos/campos';
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../utils/getTraducoes';
import { getDadosToOptions } from '../utils/toolsforms';

class DadosComerciais extends React.Component {

    state = {
        especificacargo: false
    }

    handleCargos = (cargos) => {        
        let result = getDadosToOptions(cargos,'idcargo', trad, this.props.trads,tradCampo(this.props.lingua),'SELECIONE');
        return result;
    }

    handleCargoEspecificar = (value) => {
        const cargo = this.props.dadoscargos.filter(itens => (itens.idcargo===parseInt(value)));
        this.setState({
            especificacargo: cargo[0].outros==='S'
        })
    }
    
    render(){

        if(!this.props.dadoscargos.length){
            return null;
        }
        
        const trads = this.props.trads;
        const lingua = this.props.lingua;
        const required = value => (value ? undefined : trad(trads,'JSOBRIGATORIO',lingua));
        return (
            <Card className='mb-3'>
                <Card.Header><Card.Title>{trad(trads,'COMERCIAIS',lingua)}</Card.Title></Card.Header>
                <Card.Body>
                    <Form.Row>
                        <Form.Group as={Col} md="2" controlId="idcargo" style={this.props.styles['idcargo']?this.props.styles['idcargo']:{}}>
                            <Field 
                            styles={this.props.styles}
                            placeholder={trad(trads,'CARGO',lingua)} 
                            options={
                                this.handleCargos(this.props.dadoscargos)
                            }
                            label={trad(trads,'CARGO',lingua)} name='idcargo' component={camposelect} />
                            <OnChange name='idcargo'>
                                {this.handleCargoEspecificar}
                            </OnChange>
                        </Form.Group>
                        {this.state.especificacargo?
                        <Form.Group as={Col} md="10" controlId="outroscargo" style={this.props.styles['outroscargo']?this.props.styles['outroscargo']:{}}>
                            <Field type='text' 
                            required={required}
                            styles={this.props.styles}
                            placeholder={trad(trads,'ESPECIFIQUE',lingua)} 
                            label={trad(trads,'ESPECIFIQUE',lingua)} name='outroscargo' component={campotexto} />
                        </Form.Group>
                        :
                        null
                        }
                        <Form.Group as={Col} md="10" controlId="cargocredencial" style={this.props.styles['cargocredencial']?this.props.styles['cargocredencial']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'CARGO_CREDENCIAL',lingua)} 
                            label={trad(trads,'CARGO_CREDENCIAL',lingua)} name='cargocredencial' component={campotexto} />
                        </Form.Group>                            
                    </Form.Row>
                </Card.Body>
            </Card>
        );
    }
}

export default DadosComerciais;